<template>
  <el-card class="box-card user" @click="adminshow">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span class="font-sz24">企业管理</span>
      <div class="head-text fr-martop-4">
        <!-- 新建事件 -->
        <el-input
          placeholder="请输入单位名称"
          class="search-input"
          v-model="query"
        ></el-input>
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="getData"
          class="mar-r80"
        ></el-button>
        <el-button type="primary" @click="addEnterpriseTrue" class="mar0-4"
          >新增</el-button
        >
        <el-button type="primary" class="mar0-4" @click="exportExcel"
          >导出</el-button
        >
        <el-button type="success" @click="patchSet" class="mar0-4"
          >功能配置</el-button
        >
        <el-button type="danger" @click="delCompany">删除</el-button>
      </div>
    </div>

    <div class="enterprise-table">
      <!-- 表格 -->
      <el-table
        height="76vh"
        :data="companiesList"
        @selection-change="selectChange"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          align="center"
          type="index"
          width="50"
          label="序号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="comp02"
          label="公司名称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="comp07"
          label="电话"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="comp06"
          label="地址"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="comp04"
          label="邮箱"
          sortable
        ></el-table-column>
        <el-table-column
          align="center"
          prop="comp09"
          label="用户容量"
          sortable
        ></el-table-column>
        <el-table-column
          align="center"
          prop="comp12"
          label="项目容量"
          sortable
        ></el-table-column>
        <el-table-column
          align="center"
          prop="comp11"
          label="空间容量"
          sortable
        ></el-table-column>
        <el-table-column
          align="center"
          prop="comp14"
          width="180"
          label="有效期"
          sortable
        ></el-table-column>
        <el-table-column align="center" label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              plain
              @click="userDialogFormVisible(scope.row)"
              >用户</el-button
            >
            <el-button
              type="primary"
              class="mar-left4"
              size="small"
              plain
              @click="openproject(scope.row)"
              >项目</el-button
            >
            <el-button
              size="small"
              class="mar-left4"
              type="primary"
              plain
              @click="functionalityDialog(scope.row)"
              >功能</el-button
            >
            <el-button
              type="primary"
              class="mar-left4"
              size="small"
              plain
              @click="editorDialogFormVisible(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="page">
      <el-pagination
        class="mar-top20"
        align="center"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 新增用户 -->
    <el-dialog
      :close-on-click-modal="false"
      title="新增用户"
      :visible.sync="addDialogFormVisible"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        ref="addForm"
        :rules="addFormRules"
      >
        <el-form-item label="姓名" prop="user04">
          <el-input
            v-model="addForm.user04"
            auto-complete="off"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="user02">
          <el-input
            v-model="addForm.user02"
            auto-complete="off"
            placeholder="请输入账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="user11">
          <el-input
            v-model="addForm.user11"
            auto-complete="off"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="user03">
          <el-input
            show-password
            v-model="addForm.user03"
            auto-complete="off"
            placeholder="请输入登录密码"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item label="重复密码" prop="YzPassword">
          <el-input
            show-password
            v-model="YzPassword"
            auto-complete="off"
            placeholder="请重复输入登录密码"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属组织" prop="deptIds">
          <el-cascader
            v-model="addForm.deptIds"
            placeholder="请选择组织"
            :options="deptIDList"
            :props="{
              checkStrictly: true,
              value: 'ID',
              label: 'label',
              children: 'children',
            }"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="职位" prop="position">
          <el-select v-model="addForm.position" placeholder="请选择职位">
            <el-option
              v-for="(item, index) in positionList"
              :key="index.cptt03"
              :label="item.cptt03"
              :value="item.cptt03"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="性别" prop="user05">
          <el-select
            filterable
            v-model="addForm.user05"
            placeholder="请选择性别"
          >
            <el-option label="男" value="男"></el-option>
            <el-option label="女" value="女"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出生年月" prop="user06">
          <el-date-picker
            v-model="addForm.user06"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="职称" prop="user07">
          <el-select v-model="addForm.user07" placeholder="请选择职称">
            <el-option
              v-for="(item, index) in jobs"
              :key="index"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学历" prop="user08">
          <el-select
            filterable
            v-model="addForm.user08"
            placeholder="请选择学历"
          >
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="毕业院校" prop="user09">
          <el-input
            v-model="addForm.user09"
            auto-complete="off"
            placeholder="请输入毕业院校"
          ></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="user10">
          <div class="container">
            <div class="dome-main">
              <div
                class="city-picker-selector"
                id="city-picker-selector3"
              ></div>
            </div>
          </div>
          <el-input v-model="detialAdree3" type="textarea"></el-input>
        </el-form-item>
        <!-- <el-form-item label="邮箱" prop="user12">
          <el-input
            v-model="addForm.user12"
            auto-complete="off"
            placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="adduser2('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 批量文件添加节点 -->
    <el-dialog
      :close-on-click-modal="false"
      title="xlsx导入"
      :visible.sync="batchAddFile"
      width="40%"
      center
      v-loading="Uploadloading"
    >
      <p>
        点击下载模板文件：
        <a style="color: red; cursor: pointer" @click="ExportPersonTemplate"
          >示例表格.XLSX</a
        >并按要求填好后上传
      </p>
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="actionUrlUser"
        :on-change="handleChangeUser"
        :file-list="fileListUser"
        :limit="1"
        :data="uploadData"
        :before-upload="beforeUploadUser"
        accept=".xlsx"
        :auto-upload="false"
        :on-success="uploadSuccessUser"
        :headers="importHeadersUser"
        :on-exceed="handleExceedUser"
      >
        <el-button slot="trigger" size="small" type="primary"
          >选择文件</el-button
        >
        <el-button
          style="margin-left: 10px"
          size="small"
          type="success"
          @click="submitUpload"
          >上传到服务器</el-button
        >
        <div slot="tip" class="el-upload__tip">只能上传xlsx文件</div>
      </el-upload>
    </el-dialog>
    <!-- 用户列表 -->
    <div class="yh-table">
      <el-dialog
        :close-on-click-modal="false"
        title="用户列表"
        :visible.sync="userDialogFormVisible1"
        width="90%"
        top="2%"
      >
        <el-row>
          <el-col :span="6" :offset="12">
            <el-input
              placeholder="请输入用户名称"
              class="search-input width80"
              v-model="userName"
            ></el-input>
            <el-button icon="el-icon-search" @click="aa"></el-button>
          </el-col>
          <el-col :span="1">
            <el-button
              @click="batchAddFile = true"
              type="primary"
              class="mar-bot20"
              >导入员工</el-button
            >
          </el-col>
          <el-col :span="1" :offset="1">
            <el-button @click="invitaation" type="primary" class="mar-bot20"
              >邀请员工</el-button
            >
          </el-col>
          <el-col :span="1" :offset="1">
            <el-button @click="adduser" type="primary" class="mar-bot20"
              >新增员工</el-button
            >
          </el-col>
        </el-row>
        <el-table
          class="margin-20 table width100"
          v-loading="loading"
          :data="userList2"
          border
          max-height="550"
        >
          <el-table-column
            align="center"
            prop="selection"
            type="selection"
            width="55"
          ></el-table-column>
          <!-- <el-table-column align="center" prop="id" label="ID" width="80"></el-table-column> -->
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Account"
            label="账号"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Name"
            label="姓名"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Sex"
            label="性别"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Job"
            label="职位"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="PhoneNumber"
            label="手机号"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Email"
            label="邮箱"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Address"
            label="地址"
          ></el-table-column>
          <el-table-column
            prop="AddTime"
            align="center"
            label="添加时间"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="220">
            <template slot-scope="scope">
              <el-button
                size="small"
                class="mar-r10"
                type="primary"
                plain
                @click="seeDialogFormVisible(scope.row)"
                >查看</el-button
              >
              <el-button
                size="small"
                plain
                v-if="scope.row.CompanyAdmin == 0 ? false : true"
                type="primary"
                @click="setAdmin(scope.row)"
                >设置企管</el-button
              >
              <el-button
                plain
                v-if="scope.row.CompanyAdmin == 1 ? false : true"
                size="mini"
                type="danger"
                @click="outAdmin(scope.row)"
                >取消企管</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            class="mar-top20"
            align="center"
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page="pagenum"
            :page-sizes="[10, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total2"
          ></el-pagination>
        </div>
      </el-dialog>
    </div>
    <!-- 邀请用户 -->
    <el-dialog
      :close-on-click-modal="false"
      title="用户邀请"
      :visible.sync="invitaationIsShow"
      width="70%"
    >
      <div class="head-text fr-martop-4">
        <el-input
          placeholder="请输入用户姓名"
          class="search-input mar-r80"
          v-model="userQuery"
        ></el-input>
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="GetUserList"
          class="mar-r80"
        ></el-button>
      </div>
      <div class="user-table">
        <el-table
          :data="userList"
          class="width100"
          v-loading="loading"
          :default-sort="{ prop: 'date', order: 'ascending' }"
        >
          <el-table-column
            align="center"
            type="selection"
            width="55"
          ></el-table-column>
          <el-table-column
            align="center"
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Account"
            label="帐号"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Name"
            label="姓名"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Sex"
            label="性别"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Company"
            label="公司"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Job"
            label="职称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="PhoneNumber"
            label="手机号"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Email"
            label="邮箱"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Address"
            label="地点"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="CompanyAdmin"
            label="管控公司"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="AddTime"
            width="160"
            label="创建时间"
            sortable
          ></el-table-column>
          <el-table-column class="test" align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                plain
                @click="invitaationUser(scope.row)"
                >邀请</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          class="mar30-40"
          align="center"
          @size-change="userHandleSizeChange"
          @current-change="userHandleCurrentChange"
          :current-page="userPagenum"
          :page-sizes="[10, 50, 100]"
          :page-size="userPagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="userTotal"
        ></el-pagination>
      </div>
    </el-dialog>
    <!-- 邀请选择部门 -->
    <el-dialog
      :close-on-click-modal="false"
      title="部门选择"
      :visible.sync="deptInvation"
      width="30%"
    >
      <el-row>
        <el-col :span="12">
          <el-select v-model="deptId" placeholder="请选择">
            <el-option
              v-for="item in qyList"
              :key="item.dept01"
              :label="item.dept02"
              :value="item.dept01"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="5" :offset="7">
          <el-button @click="invation">邀请</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 删除企业 -->
    <el-dialog
      :close-on-click-modal="false"
      title="删除企业"
      :visible.sync="delCompanyShow"
      width="30%"
    >
      <el-select
        v-model="delCompanyIds"
        filterable
        class="width80"
        placeholder="请选择删除的企业"
      >
        <el-option
          v-for="item in allCompaniesList"
          :key="item.comp01"
          :label="item.comp02"
          :value="item.comp01"
        ></el-option>
      </el-select>
      <el-button type="primary" class="mar-left30" @click="submitDelCompany"
        >确定</el-button
      >
    </el-dialog>
    <!-- 新增企业 -->
    <el-dialog
      :close-on-click-modal="false"
      title="新增企业"
      :visible.sync="addEnterprise1"
      width="90%"
    >
      <el-row>
        <el-col :span="11" :offset="1">
          <el-upload
            ref="upload2"
            class="avatar-uploader"
            :action="actionUrl2"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :on-change="onAvatarChange"
            :auto-upload="false"
            :show-file-list="false"
            :data="addqiye"
            :headers="importHeaders"
          >
            <!-- <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过10M</div>-->
            <img v-if="imageUrl1" :src="imageUrl1" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-form
            :model="addqiye"
            label-width="120px"
            ref="addqiye"
            :rules="addqiyeRules"
          >
            <el-form-item label="客户编码" prop="comp03">
              <el-input
                v-model="addqiye.comp03"
                auto-complete="off"
                placeholder="请输入客户编码"
              ></el-input>
            </el-form-item>
            <el-form-item label="单位简称" prop="comp18">
              <el-input
                v-model="addqiye.comp18"
                auto-complete="off"
                placeholder="请输入单位简称"
              ></el-input>
            </el-form-item>
            <el-form-item label="单位名称" prop="comp02">
              <el-input
                v-model="addqiye.comp02"
                auto-complete="off"
                placeholder="请输入单位名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="comp04">
              <el-input
                v-model="addqiye.comp04"
                auto-complete="off"
                placeholder="请输入单位邮箱"
              ></el-input>
            </el-form-item>
            <el-form-item label="单位类别" prop="comp05">
              <el-select
                filterable
                v-model="addqiye.comp05"
                placeholder="请输入单位类别"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="地址" prop="comp06">
              <div class="container">
                <div class="dome-main">
                  <div
                    class="city-picker-selector"
                    id="city-picker-selector1"
                  ></div>
                </div>
              </div>
              <el-input v-model="detialAdree" type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="comp07">
              <el-input
                v-model="addqiye.comp07"
                auto-complete="off"
                placeholder="请输入单位电话"
              ></el-input>
            </el-form-item>
            <el-form-item label="网址" prop="comp08">
              <el-input
                v-model="addqiye.comp08"
                auto-complete="off"
                placeholder="请输入单位网址"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="10" :offset="2">
          <el-form :model="addqiye" label-width="85px" ref="addqiye2">
            <el-form-item label="可创建用户" prop="comp09">
              <el-input
                type="number"
                v-model.number="addqiye.comp09"
                auto-complete="off"
                placeholder="请输入可创建用户，为整数类型！"
              ></el-input>
            </el-form-item>
            <el-form-item label="可创建项目" prop="comp12">
              <el-input
                type="number"
                v-model.number="addqiye.comp12"
                auto-complete="off"
                placeholder="请输入可创建项目，为整数类型！"
              ></el-input>
            </el-form-item>
            <el-form-item label="可用空间" prop="comp11">
              <el-input
                type="number"
                v-model.number="addqiye.comp11"
                auto-complete="off"
                placeholder="请输入可用空间"
              ></el-input>
            </el-form-item>
            <el-form-item label="授权限期" prop="comp14">
              <el-date-picker
                v-model="addqiye.comp14"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="高级授权">
              <el-checkbox-group v-model="permissionsList">
                <el-checkbox
                  :label="item.value"
                  v-for="item in permissionsList2"
                  :key="item.value"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2" :offset="11">
          <el-button
            type="primary"
            @click="addEnterprise('addqiye', 'addqiye2')"
            >保存</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="danger" @click="addEnterprise1 = false"
            >取消</el-button
          >
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 这里是编辑 -->
    <el-dialog
      :close-on-click-modal="false"
      title="编辑企业"
      :visible.sync="editorEnterprise1"
      width="70%"
      top="3%"
    >
      <el-row>
        <el-col :span="11" :offset="1">
          <el-upload
            class="avatar-uploader"
            :action="actionUrl3"
            :show-file-list="false"
            :data="updataLogo"
            :headers="importHeaders"
            :on-success="handleAvatarSuccess2"
            :before-upload="beforeAvatarUpload2"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-form
            :model="editorForm"
            label-width="100px"
            ref="addForm"
            :rules="addqiyeRules"
          >
            <el-form-item label="客户编码" prop="comp03">
              <el-input
                v-model="editorForm.comp03"
                auto-complete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="单位简称" prop="comp18">
              <el-input
                v-model="editorForm.comp18"
                auto-complete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="单位名称" prop="comp02">
              <el-input
                v-model="editorForm.comp02"
                auto-complete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="comp04">
              <el-input
                v-model="editorForm.comp04"
                auto-complete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="单位类别" prop="comp05">
              <el-input
                v-model="editorForm.comp05"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="11" :offset="1">
          <el-form :model="editorForm" label-width="85px" ref="editorForm">
            <el-form-item label="地址" prop="comp06">
              <div class="container">
                <div class="dome-main">
                  <div
                    class="city-picker-selector"
                    id="city-picker-selector2"
                  ></div>
                </div>
              </div>
              <el-input v-model="detialAdree2" type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="comp07">
              <el-input
                v-model="editorForm.comp07"
                auto-complete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="网址" prop="comp08">
              <el-input
                v-model="editorForm.comp08"
                auto-complete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="可创建用户" prop="comp09">
              <el-input
                v-model="editorForm.comp09"
                auto-complete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="可创建项目" prop="comp12">
              <el-input
                v-model="editorForm.comp12"
                auto-complete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="可用空间" prop="comp11">
              <el-input
                v-model="editorForm.comp11"
                auto-complete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="授权限期" prop="comp14">
              <el-date-picker
                v-model="editorForm.comp14"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="高级授权">
              <el-checkbox-group v-model="permissionsList">
                <el-checkbox
                  :label="item.value"
                  v-for="item in permissionsList2"
                  :key="item.value"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2" :offset="11">
          <el-button type="primary" @click="editorEnterprise">保存</el-button>
        </el-col>
        <el-col :span="2">
          <el-button type="danger" @click="editorEnterprise1 = false"
            >取消</el-button
          >
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 这里是项目 -->
    <el-dialog
      :close-on-click-modal="false"
      title
      :visible.sync="project1"
      :fullscreen="isqp"
    >
      <el-card class="box-card">
        <el-header>
          <span class="font-sz24">项目列表</span>
          <div class="head-text fr-martop-4">
            <!-- 新建事件 -->
            <el-input
              placeholder="请输入项目名称"
              class="search-input"
              v-model="query2"
            ></el-input>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="bb"
              class="mar-r80"
            ></el-button>
            <el-button type="primary" class="mar0-4" @click="modelList"
              >模型管理器</el-button
            >
            <el-button type="primary" @click="exportExcel">导出</el-button>
          </div>
        </el-header>
        <el-container>
          <div class="mar-top20">
            <el-aside width="200px" class="elAside">
              <el-button type="primary" size="small" @click="showAll"
                >显示全部项目</el-button
              >
              <div class="zTreeDiv">
                <ul id="deptTree" class="ztree"></ul>
              </div>
            </el-aside>
          </div>
          <el-main>
            <el-table
              class="margin-20 table width100"
              v-loading="loading"
              :data="projectList"
              border
              max-height="700"
            >
              <el-table-column
                type="selection"
                align="center"
                width="55"
              ></el-table-column>
              <!-- <el-table-column prop="proj01" align="center" label="ID" width="80"></el-table-column> -->
              <el-table-column
                type="index"
                width="50"
                label="序号"
              ></el-table-column>
              <el-table-column
                prop="proj03"
                align="center"
                label="项目名称"
              ></el-table-column>
              <el-table-column
                prop="proj02"
                align="center"
                label="项目编号"
              ></el-table-column>
              <el-table-column
                prop="admin"
                align="center"
                label="BIM负责人"
              ></el-table-column>
              <el-table-column
                prop="proj08"
                align="center"
                label="咨询合同"
              ></el-table-column>
              <el-table-column
                prop="proj10"
                align="center"
                label="建筑类别"
              ></el-table-column>
              <el-table-column
                prop="proj15"
                align="center"
                label="建筑单位"
              ></el-table-column>
              <el-table-column
                prop="proj13"
                align="center"
                label="项目地点"
              ></el-table-column>
              <el-table-column
                prop="phone"
                align="center"
                label="电话"
              ></el-table-column>
              <el-table-column
                prop="proj22"
                align="center"
                label="创建时间"
              ></el-table-column>
              <el-table-column align="center" label="操作" width="200">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    plain
                    size="mini"
                    @click="seeModelList(scope.row)"
                    >项目详情</el-button
                  >
                  <el-button
                    type="primary"
                    plain
                    class="mar-left4"
                    size="mini"
                    @click="modelListInfo(scope.row)"
                    >模型</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="mar-top20"
              @size-change="handleSizeChange4"
              @current-change="handleCurrentChange4"
              :current-page="pageIndex3"
              :page-sizes="[10, 50, 100]"
              :page-size="pageSize3"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total4"
            ></el-pagination>
          </el-main>
        </el-container>
      </el-card>
    </el-dialog>
    <!-- 查看用户详情 -->
    <el-dialog
      :close-on-click-modal="false"
      title="查看用户详情"
      :visible.sync="seeDialogFormVisible1"
      width="100%"
    >
      <el-row>
        <el-col :span="11">
          <el-form :model="userInfoList" label-width="80px" ref="userInfoList">
            <el-form-item label="账号" prop="user02">
              <el-input
                v-model="userInfoList.user02"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="user04">
              <el-input
                v-model="userInfoList.user04"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="user05">
              <el-input
                v-model="userInfoList.user05"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="出生年月" prop="user06">
              <el-date-picker
                v-model="userInfoList.user06"
                type="date"
                placeholder="选择日期"
                :disabled="true"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="职称" prop="user07">
              <el-input
                v-model="userInfoList.user07"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="学历" prop="user08">
              <el-input
                v-model="userInfoList.user08"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="毕业院校" prop="user09">
              <el-input
                v-model="userInfoList.user09"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系地址" prop="user10">
              <el-input
                v-model="userInfoList.user10"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="user11">
              <el-input
                v-model="userInfoList.user11"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="user12">
              <el-input
                v-model="userInfoList.user12"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="添加时间" prop="user15">
              <el-input
                v-model="userInfoList.user15N"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="11" :offset="1">
          <el-select
            filterable
            v-model="companyID"
            placeholder="显示该用户加入得公司"
            @change="jopProject"
          >
            <el-option
              :label="item.comp02"
              :value="item.comp01"
              v-for="(item, index) in companyList"
              :key="index"
            ></el-option>
          </el-select>
          <div class="user-loading">
            <img src="../../assets/img/dw.png" alt />
            <p>
              机构组织：
              <span>{{ project.dept }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="../../assets/img/zw.png" alt />
            <p>
              担任职位：
              <span>{{ project.zhiwei }}</span>
            </p>
          </div>
          <!-- 1111 -->
          <div class="user-loading">
            <el-button size="small" @click="jopProject(1)"
              >管理的项目</el-button
            >
            <el-button size="small" @click="jopProject(0)" class="mar-left10"
              >参与的项目</el-button
            >
          </div>
          <div class="user-loading-table">
            <el-table
              class="margin-20 table width100"
              v-loading="loading"
              :data="projectList"
              border
            >
              <el-table-column
                align="center"
                type="selection"
                width="55"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="proj01"
                label="ID"
                width="80"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="proj02"
                label="项目编号"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="proj03"
                label="项目名称"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="rolename"
                label="岗位"
              ></el-table-column>
            </el-table>
            <div class="page">
              <el-pagination
                class="mar-top30"
                align="center"
                @size-change="handleSizeChange3"
                @current-change="handleCurrentChange3"
                :current-page="pageIndex2"
                :page-sizes="[10, 50, 100]"
                :page-size="pageSize2"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total3"
              ></el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 查看项目详情 -->
    <el-dialog
      :close-on-click-modal="false"
      title="项目详情"
      :visible.sync="projectDetails"
      width="60%"
      top="2%"
    >
      <el-row>
        <el-col :span="12" :offset="2">
          <div class="user-loading">
            <img src="@/assets/img/xm.png" alt />
            <p>
              项目名称:
              <span>{{ projectInfo.proj03 }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/kj.png" alt />
            <p>
              项目简称:
              <span>{{ projectInfo.proj07 }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/bh.png" alt />
            <p>
              项目编号:
              <span>{{ projectInfo.proj02 }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/ren.png" alt />
            <p>
              BIM负责人:
              <span>{{ projectInfo.admin }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/ht.png" alt />
            <p>
              咨询合同:
              <span>{{ projectInfo.proj08 }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/mx.png" alt />
            <p>
              BIM耗时:
              <span>{{ projectInfo.proj09 }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/td.png" alt />
            <p>
              成员数量:
              <span>{{ projectInfo.peoplesum }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/rl.png" alt />
            <p>
              数据容量:
              <span>{{ projectInfo.proj04 }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/sj.png" alt />
            <p>
              创建日期:
              <span>{{ projectInfo.proj22 }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/dz.png" alt />
            <p>
              项目地点:
              <span>{{ projectInfo.proj13 }}</span>
            </p>
          </div>
        </el-col>
        <el-col :span="8" :offset="1">
          <div class="user-loading">
            <img src="@/assets/img/xm.png" alt />
            <p>
              建筑类别:
              <span>{{ projectInfo.proj10 }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/xm.png" alt />
            <p>
              服务阶段:
              <span>{{ projectInfo.proj11 }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/xm.png" alt />
            <p>
              项目面积:
              <span>{{ projectInfo.proj12 }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/xm.png" alt />
            <p>
              总体工期:
              <span>{{ projectInfo.proj14 }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/xm.png" alt />
            <p>
              建筑单位:
              <span>{{ projectInfo.proj15 }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/xm.png" alt />
            <p>
              设计单位:
              <span>{{ projectInfo.proj16 }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/xm.png" alt />
            <p>
              施工单位:
              <span>{{ projectInfo.proj17 }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/xm.png" alt />
            <p>
              监理单位:
              <span>{{ projectInfo.proj18 }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/xm.png" alt />
            <p>
              总体投资:
              <span>{{ projectInfo.proj19 }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/xm.png" alt />
            <p>
              开工日期:
              <span>{{ projectInfo.proj20 }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="@/assets/img/xm.png" alt />
            <p>
              计划竣工:
              <span>{{ projectInfo.proj21 }}</span>
            </p>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="mar-top10" :span="20" :offset="2"
          >项目说明：{{ projectInfo.proj23 }}</el-col
        >
      </el-row>
    </el-dialog>
    <!-- 这里是模型管理器 -->
    <el-dialog
      :close-on-click-modal="false"
      title="模型管理器"
      :visible.sync="modelList3"
      width="80%"
      top="1%"
    >
      <el-row>
        <el-col :span="8" :offset="16">
          <el-input
            placeholder="请输入项目名称"
            class="search-input"
            v-model="modelQuery"
          ></el-input>
          <el-button
            icon="el-icon-search"
            @click="modelList"
            class="mar-r80"
          ></el-button>
        </el-col>
      </el-row>
      <el-table
        class="table width100"
        v-loading="loading"
        :data="modelList1"
        max-height="550"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column
          align="center"
          prop="mode02"
          label="文件名称"
        ></el-table-column>
        <el-table-column align="center" prop="mode10" label="文件大小">
          <template slot-scope="scope"
            >{{ Math.floor(scope.row.mode10 / 1024 / 1024) }}MB</template
          >
        </el-table-column>
        <el-table-column align="center" prop="mode04" label="上传文件大小">
          <template slot-scope="scope"
            >{{ Math.floor(scope.row.mode04 / 1024 / 1024) }}MB</template
          >
        </el-table-column>
        <el-table-column
          align="center"
          prop="mode05"
          label="版本备注"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="mode06"
          label="联系人"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="mode07"
          label="邮箱"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="mode08"
          label="电话"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="versionNum"
          label="版本数量"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="mode11"
          label="更新时间"
        ></el-table-column>
        <el-table-column align="center" label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              plain
              @click="modelView(scope.row)"
              >浏览</el-button
            >
            <el-button
              size="mini"
              type="primary"
              class="mar-left5"
              plain
              @click="editModelDetil(scope.row)"
              >更新</el-button
            >
            <el-button
              size="mini"
              type="primary"
              class="mar-left5"
              plain
              @click="deleteModel(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          class="mar-top20"
          align="center"
          @size-change="handleSizeChange5"
          @current-change="handleCurrentChange5"
          :current-page="pageIndex4"
          :page-sizes="[10, 50, 100]"
          :page-size="pageSize4"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total5"
        ></el-pagination>
      </div>
      <div>
        <el-row>
          <el-col :span="2" :offset="12">
            <el-button type="primary" @click="updataModel">上传模型</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <!-- 这里是新增模型updataModel1 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="updataModelTitle"
      :visible.sync="updataModel1"
      width="50%"
    >
      <el-form
        :model="addModelList"
        label-width="80px"
        ref="addModelList"
        v-loading="loading2"
      >
        <el-form-item label="文件名称" prop="mode02">
          <el-input
            v-model="addModelList.mode02"
            auto-co
            vmplete="off"
            placeholder="请输入文件名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="版本备注" prop="mode05">
          <el-input
            v-model="addModelList.mode05"
            auto-complete="off"
            placeholder="请输入版本备注"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="mode06">
          <el-input
            v-model="addModelList.mode06"
            auto-complete="off"
            placeholder="请输入联系人"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系邮箱" prop="mode07">
          <el-input
            v-model="addModelList.mode07"
            auto-complete="off"
            placeholder="请输入联系邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="mode08">
          <el-input
            v-model="addModelList.mode08"
            auto-complete="off"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="mode03">
          <el-input
            v-model="addModelList.mode03"
            auto-complete="off"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <el-form-item label="模型文件" prop="mode09">
          <el-upload
            ref="upload"
            class="upload-demo"
            :action="actionUrl"
            :on-change="handleChange"
            :file-list="fileList"
            :limit="1"
            :data="addModelList"
            :before-upload="beforeUpload"
            :accept="accept"
            :auto-upload="false"
            :on-success="uploadSuccess"
            :headers="importHeaders"
            :on-exceed="handleExceed"
            :on-error="uploadError"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传{{ this.uploadType }}文件，且不超过1G
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <el-row>
        <el-col :span="6" :offset="6">
          <el-button @click="addModel">确定</el-button>
        </el-col>
        <el-col :span="6">
          <el-button @click="updataModel1 = false">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 这里是模型列表 -->
    <el-dialog
      :close-on-click-modal="false"
      title="模型列表"
      :visible.sync="showModelList"
      width="80%"
      top="2%"
    >
      <div class="mx-table">
        <el-table
          class="margin-20 table width100"
          v-loading="loading"
          :data="ModelList"
          border
          height="500px"
        >
          <el-table-column
            align="center"
            type="selection"
            width="55"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="mode01"
            label="ID"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="mode02"
            label="文件名称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="mode10"
            label="文件大小"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="mode03"
            label="专业备注"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="mode04"
            label="压缩率"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="mode05"
            label="版本备注"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="mode06"
            label="联系人"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="mode07"
            label="邮箱"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="mode08"
            label="电话"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="mode03"
            label="备注"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Mode11"
            label="更新时间"
          ></el-table-column>
          <el-table-column align="center" label="操作" min-width="100">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                plain
                @click="modelView(scope.row)"
                >浏览</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 这里是模型修改 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="updataEditModelTitle"
      :visible.sync="editModel1"
      width="50%"
    >
      <el-form
        :model="editModel"
        label-width="80px"
        ref="editModel"
        v-loading="editModelLoading"
      >
        <el-form-item label="文件名称" prop="mode02">
          <el-input
            v-model="editModel.mode02"
            auto-co
            vmplete="off"
            placeholder="请输入文件名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="版本备注" prop="mode05">
          <el-input
            v-model="editModel.mode05"
            auto-complete="off"
            placeholder="请输入版本备注"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="mode06">
          <el-input
            v-model="editModel.mode06"
            auto-complete="off"
            placeholder="请输入联系人"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系邮箱" prop="mode07">
          <el-input
            v-model="editModel.mode07"
            auto-complete="off"
            placeholder="请输入联系邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="mode08">
          <el-input
            v-model="editModel.mode08"
            auto-complete="off"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="mode03">
          <el-input
            v-model="editModel.mode03"
            auto-complete="off"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <el-form-item label="模型文件" prop="mode09">
          <el-upload
            ref="editModelList"
            class="upload-demo"
            :action="editModelActionUrl"
            :on-change="editModelHandleChange"
            :file-list="editModelFileList"
            :limit="1"
            :data="editModel"
            :before-upload="editModelBeforeUpload"
            :accept="accept"
            :auto-upload="false"
            :on-success="editModelUploadSuccess"
            :headers="importHeaders"
            :on-exceed="handleExceed"
            :on-error="uploadError"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传{{ this.uploadType }}文件，且不超过1G
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <el-row>
        <el-col :span="6" :offset="6">
          <el-button @click="editModelList">确定</el-button>
        </el-col>
        <el-col :span="6">
          <el-button @click="editModel1 = false">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 选择修改模式 -->
    <el-dialog
      :close-on-click-modal="false"
      title="选择上传模型的类型"
      :visible.sync="changEditUploadModel"
      width="30%"
    >
      <div class="changUpload">
        <div class="ZIP" @click="updataEditModelShow">
          <p>上传SVFZIP文件</p>
          <img src="@/assets/img/upload.png" alt />
          <p>通过AUTODESK云端进行轻量化转后的文件</p>
        </div>
        <div class="REVIT" @click="updataEditModelShowREVIT">
          <p>上传REVIT/NAVISWORKS文件并转化</p>
          <img src="@/assets/img/upload.png" alt />
          <p>最高支持2021版本文件</p>
        </div>
      </div>
    </el-dialog>
    <!-- 选择上传模式 -->
    <el-dialog
      :close-on-click-modal="false"
      title="选择上传模型的类型"
      :visible.sync="changUploadModel"
      width="30%"
    >
      <div class="changUpload">
        <div class="ZIP" @click="updataModelShow">
          <p>上传SVFZIP文件</p>
          <img src="@/assets/img/upload.png" alt />
          <p>通过AUTODESK云端进行轻量化转后的文件</p>
        </div>
        <div class="REVIT" @click="updataModelShowREVIT">
          <p>上传REVIT/NAVISWORKS文件并转化</p>
          <img src="@/assets/img/upload.png" alt />
          <p>最高支持2021版本文件</p>
        </div>
      </div>
    </el-dialog>

    <!-- 企管功能弹窗 -->
    <functionaly ref="functionaly"></functionaly>

    <!-- 批量设置企业功能 -->
    <el-dialog :visible.sync="func_functionShow" width="40%">
      <template slot="title">
        <el-row :gutter="24" style="margin-right: 20px">
          <el-col :span="7">
            <h2>批量功能配置</h2>
          </el-col>
          <el-col :span="2" :offset="2">
            <el-button type="success" @click="func_Allcheck">全选</el-button>
          </el-col>
          <el-col :span="2" :offset="2">
            <el-button type="primary" @click="func_UpdateFuncTempLinkCompany"
              >保存</el-button
            >
          </el-col>
        </el-row>
      </template>
      <el-container style="height: 65vh">
        <div class="mar-top20" style="width: 100%">
          <div style="margin: 20px">
            <el-input
              id="key"
              placeholder="请输入内容"
              v-model="func_functionSearch"
              @input="inputChange"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                class="mar-t80"
              ></el-button>
            </el-input>
          </div>
          <zTree
            style="height: 500px"
            ref="tree"
            @updateIds="func_updateIds"
            :treeData="func_zNodes"
            :initId="false"
            :item="func_item"
          ></zTree>
        </div>
      </el-container>
    </el-dialog>
  </el-card>
</template>
<script>
import FileSaver from "file-saver";
import functionaly from "@/components/functionaly.vue";
import XLSX from "xlsx";
import {
  GetCompanyList,
  GetCompnayUsers,
  AddCompany,
  AddCompanyUser,
  GetProjectDept,
  GetCompanyProjectList,
  GetUserInfo,
  GetUserCompanyList,
  GetProjectList,
  GetProjectInfo,
  GetModelList,
  AddModelfile,
  DelModelFile,
  GetCompanyinfo,
  EditCompany,
  SettingCompanyAdmin,
  CanelCompanyAdmin,
  GetProjectgroupTree,
  GetProjectModelList,
  GetUserList,
  InviteCorporateGovernanceUser,
  GetCorporateGovernanceDepartment,
  UpdateModelFile,
  GetProjectgroupZTree,
  DelCompany,
  GetCompanyTitel,
  ExportPersonTemplate,
  GetFunctionTemplate,
  UpdateFuncTempLinkCompany,
} from "@/setAxios.js";
import zTree from "@/components/compontZtree";
export default {
  name: "enterprise",
  props: ["showAdmin"],
  components: { functionaly, zTree },
  data() {
    // 邮箱格式验证
    var checkAge = (rule, value, callback) => {
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (this.addForm.user12.search(reg) == -1) {
        return callback(new Error("请输入正确的邮箱"));
      } else {
        callback();
      }
    };
    // 手机格式验证
    var checkAge1 = (rule, value, callback) => {
      var reg = /^1[3-9]\d{9}$/;
      if (this.addForm.user11.search(reg) == -1) {
        return callback(new Error("请输入正确的手机"));
      } else {
        callback();
      }
    };
    // 重复密码一致验证
    var validatePass = (rule, value, callback) => {
      if (value == null) {
        callback(new Error("请输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码至少6位"));
      } else {
        if (this.addForm.user03 != "") {
          this.$refs.addForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (this.addForm.user03 != this.YzPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      actionUrlUser: this.$store.state.baseUrl + "/api/ImportUserExcel",
      importHeadersUser: { token: localStorage.getItem("token") },
      uploadData: {
        companyId: "",
      },
      Uploadloading: false,
      fileListUser: [],
      batchAddFile: false,
      userName: "",
      // 重复密码验证
      YzPassword: null,
      zNodes: null,
      selectNode: null,
      zTeeObj: null,
      ids: "",
      // 选择上传模式
      changUploadModel: false,
      updataModelTitle: "",
      uploadType: "",
      accept: "",

      changEditUploadModel: false,
      updataEditModelTitle: "",
      Editaccept: "",

      // 邀请人当前行个人信息
      userDetail: null,
      invitaationIsShow: false,
      deptId: "",
      qyList: null,
      userQuery: "",
      deptInvation: false,
      restaurants: [],
      jobs: [
        { name: "初级" },
        { name: "中级" },
        { name: "副高级" },
        { name: "高级" },
      ],
      modelQuery: "",
      defaultExpand: true,
      showModelList: false,
      detialAdree: "",
      detialAdree2: "",
      detialAdree3: "",

      deptIds: "",
      // 这里是验证规则
      addFormRules: {
        user02: [
          { required: true, message: "请输入用户账号", trigger: "blur" },
        ],
        user03: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],
        YzPassword: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
        user04: [
          { required: true, message: "请输入用户姓名", trigger: "blur" },
        ],
        deptIds: [{ required: true, message: "请选择组织", trigger: "change" }],
        position: [
          { required: true, message: "请输入用户职位", trigger: "change" },
        ],
        user11: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkAge1, trigger: "blur" },
        ],
        user05: [{ required: true, message: "请选择性别", trigger: "blur" }],
      },
      addqiyeRules: {
        comp02: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        comp03: [
          { required: true, message: "请输入客户编码", trigger: "blur" },
        ],
        comp18: [
          { required: true, message: "请填写公司简称", trigger: "blur" },
        ],
      },
      actionUrl: "",
      editModelActionUrl: "",
      actionUrl2: this.$store.state.baseUrl + "/api/AddCompany",
      actionUrl3: this.$store.state.baseUrl + "/api/UploadLogo",
      importHeaders: { token: localStorage.getItem("token") },
      loading2: false,
      editModelLoading: false,
      fileList: [],
      editModelFileList: [],
      permissionsList: [],
      // permissionsList2: ["aaa", "ccc", "vvv"],
      permissionsList2: [
        {
          name: "上传模型",
          value: "scmx",
        },
        {
          name: "转换模型",
          value: "zhmx",
        },
        {
          name: "图纸模块",
          value: "tzmk",
        },
      ],
      // 这是项目详情
      projectInfo: [],
      // 这里是部门ID
      bid: "null",
      // 这些参数都是项目列表的
      isCollapse: false,
      menuData: [],
      total: 0,
      total2: 0,
      total3: 0,
      total4: 0,
      total5: 0,
      userTotal: 0,
      projectList: [],
      project: {},
      // 父级ID和自身ID
      IDArr: {},
      // 是否全屏
      isqp: true,
      // 用户详情
      userInfoList: [],
      // 这里是公司ID
      companyID: "",
      // 公司列表
      companyList: "",
      // 这是项目详情
      examineData: [
        {
          name: "项目地点：",
          data: "上海市-浦东新区-秀沿路",
          img: require("@/assets/img/dz.png"),
        },
      ],
      examineData2: [
        {
          name: "建筑类别：",
          data: "厂房",
          img: require("@/assets/img/jzlx.png"),
        },
        {
          name: "服务阶段：",
          data: "设计",
          img: require("@/assets/img/fwjd.png"),
        },
        {
          name: "项目面积：",
          data: "20000㎡",
          img: require("@/assets/img/xmmj.png"),
        },
        {
          name: "总体工期：",
          data: "300天",
          img: require("@/assets/img/sj.png"),
        },
        {
          name: "建设单位：",
          data: "某国资委",
          img: require("@/assets/img/jsdw.png"),
        },
        {
          name: "设计单位：",
          data: "某省院",
          img: require("@/assets/img/sjdw.png"),
        },
        {
          name: "施工单位：",
          data: "某施工总包",
          img: require("@/assets/img/sgdw.png"),
        },
        {
          name: "监理单位：",
          data: "某监理公司",
          img: require("@/assets/img/jldw.png"),
        },
        {
          name: "总体投资：",
          data: "2000000元",
          img: require("@/assets/img/ztz.png"),
        },
        {
          name: "开工日期：",
          data: "2019-09-01",
          img: require("@/assets/img/sj.png"),
        },
        {
          name: "计划竣工：",
          data: "2020-05-25",
          img: require("@/assets/img/rl-2.png"),
        },
      ],
      // 这是模型管理器
      modelList3: false,
      // 模型管理器列表
      modelList1: [],
      updataModel1: false,
      editModel1: false,
      addModelList: {
        mode02: "",
        mode03: "",
        mode04: "",
        mode05: "",
        mode06: "",
        mode07: "",
        mode08: "",
        mode09: "",
        mode13: "",
      },
      editModel: {
        mode01: "",
        mode02: "",
        mode03: "",
        mode04: "",
        mode05: "",
        mode06: "",
        mode07: "",
        mode08: "",
        mode09: "",
        mode13: "",
      },
      comp01: "",
      companiesList: [],
      allCompaniesList: [],
      userList2: [],
      imageUrl: "",
      imageUrl1: "",
      dateOfBirth: "",
      loading: false,
      userList: [],
      options: [
        { value: "国防机构", label: "国防机构" },
        { value: "政府机关", label: "政府机关" },
        { value: "事业单位", label: "事业单位" },
        { value: "企业", label: "企业" },
        { value: "个人", label: "个人" },
        { value: "社会团体", label: "社会团体" },
        { value: "民办非企业单位", label: "民办非企业单位" },
        { value: "世界五百强", label: "世界五百强" },
        { value: "央属国企", label: "央属国企" },
        { value: "地方国企", label: "地方国企" },
        { value: "群众性团体组织", label: "群众性团体组织" },
        { value: "司法鉴定机构", label: "司法鉴定机构" },
        { value: "宗教团体", label: "宗教团体" },
        { value: "境外机构", label: "境外机构" },
        { value: "医疗机构", label: "医疗机构" },
        { value: "公认机构", label: "公认机构" },
      ],
      options2: [
        { value: "小学", label: "小学" },
        { value: "初中", label: "初中" },
        { value: "高中/中专", label: "高中/中专" },
        { value: "大专", label: "大专" },
        { value: "本科", label: "本科" },
        { value: "硕士研究生", label: "硕士研究生" },
        { value: "博士研究生", label: "博士研究生" },
      ],
      // 这是两个查询
      query: "",
      query2: "",
      // 这是两个分页的参数
      pagenum: 1,
      pageIndex: 1,
      pageIndex2: 1,
      pageIndex3: 1,
      pageIndex4: 1,
      userPagenum: 1,
      pagesize: 10,
      pageSize: 10,
      pageSize2: 10,
      pageSize3: 10,
      pageSize4: 10,
      userPagesize: 10,
      editorEnterprise1: false,
      addEnterprise1: false,
      addDialogFormVisible: false,
      userDialogFormVisible1: false,
      seeDialogFormVisible1: false,
      associatedDialogFormVisible1: false,
      seeModelList1: false,
      project1: false,
      projectDetails: false,
      multipleSelection: [],
      editForm: {},
      pid: "",
      addqiye: {
        comp02: "",
        comp03: "",
        comp03: "",
        comp04: "",
        comp05: "",
        comp06: "",
        comp07: "",
        comp08: "",
        comp09: "",
        comp10: "aaa",
        comp11: "",
        comp12: "",
        comp13: "",
        comp14: "",
        comp18: "",
      },
      updataLogo: {
        qid: "",
      },
      addForm: {
        user01: 0,
        user02: "",
        user03: "",
        user04: "",
        user05: "",
        user06: "",
        user07: "",
        user08: "",
        user09: "",
        user10: "",
        user11: "",
        user12: "",
        deptIds: "",
        position: "",
      },
      positionList: [],
      deptIDList: [],
      // 这是编辑的18
      editorForm: {},
      deptList: {},
      cityName: "",
      ModelList: [],
      delCompanyShow: false,
      delCompanyIds: null,
      nvtypes: [
        ".nwc",
        ".nwf",
        ".nwc",
        ".3ds",
        ".dgn",
        ".dwf",
        ".dwg",
        ".dxf",
        ".fbx",
        ".ifc",
        ".rvt",
        ".rfa",
        ".rte",
        ".3dm",
        ".skp",
      ],
      //批量设置公司功能
      func_functionShow: false,
      func_functionSearch: "",
      func_ids: "",
      func_item: { name: "fctm02", parentName: "fctm03", id: "fctm01" },
      func_zNodes: [],
      func_companyIds: "",
    };
  },
  //   模型初始化时调用方法请求接口
  created() {
    this.getData();
  },
  methods: {
    func_Allcheck() {
      this.$refs.tree.checkAllNodes(true);
    },
    func_UpdateFuncTempLinkCompany() {
      let params = {
        Id: this.func_companyIds,
        type: 0,
        tempIds: this.func_ids,
      };
      UpdateFuncTempLinkCompany(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            message: "更新企业关联模板成功！",
            type: "success",
          });
        }
      });
    },
    inputChange(val) {
      fuzzySearch("fctm01", "#key", null, true);
    },
    patchSet() {
      if (!this.func_companyIds) {
        this.$message.error("请选择企业");
        return;
      }
      this.func_zNodes = [];
      this.func_GetCompanyFunctionTemplate();
    },
    selectChange(data) {
      this.func_companyIds = data.map((x) => x.comp01).join(",");
    },
    func_updateIds(ids) {
      this.func_ids = ids.join();
    },
    func_GetCompanyFunctionTemplate() {
      GetFunctionTemplate({}).then((res) => {
        if (res.Code > 0) {
          this.func_functionShow = true;
          this.func_zNodes = res.Data.allfunctiontemplates;
        }
      });
    },
    functionalityDialog(data) {
      this.$refs.functionaly.companyid = data.comp01;
      this.$refs.functionaly.open();
    },

    //企业导出人员模板
    async ExportPersonTemplate() {
      let res = await ExportPersonTemplate({ cid: this.pid });
      if (res.Code == 0) {
        this.$message.error(res.Message);
      } else {
        var a = document.createElement("a");
        a.setAttribute("href", this.$store.state.baseUrl + res.Data);
        a.setAttribute("target", "_blank");
        a.setAttribute("id", "js_a");
        a.setAttribute("download", "download");
        //防止反复添加
        if (document.getElementById("js_a")) {
          document.body.removeChild(document.getElementById("js_a"));
        }
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(document.getElementById("js_a"));
      }
    },
    submitUpload() {
      if (this.fileList.length > 0) {
        this.$refs.upload.submit();
      } else {
        this.$message({
          type: "warning",
          message: "请选择文件后上传",
        });
      }
    },
    handleExceedUser(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeUploadUser(file) {
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix === "xlsx";
      //(suffix);
      if (!extension) {
        this.$message({
          message: "上传文件只能是 xlsx格式!",
          type: "warning",
        });
        this.Uploadloading = true;
      }
      return extension;
    },
    handleChangeUser(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    // 上传成功
    uploadSuccessUser(data) {
      this.Uploadloading = false;
      this.batchAddFile = false;
      if (data.Code > 0) {
        this.$message({
          type: "success",
          message: data.Message,
        });
        this.aa();
      } else {
        this.$message({
          type: "warning",
          message: data.Message,
        });
      }
    },
    submitDelCompany() {
      // let ids = [];
      // this.allCompaniesList.forEach((v) => {
      //   ids.push(v.comp01);
      // });
      // if (this.delCompanyIds) {
      //   ids = ids.filter((v) => !this.delCompanyIds.includes(v));
      // }
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.delCompanyShow = false;
        const loading = this.$loading({
          lock: true,
          text: "删除中，请稍等...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        DelCompany({ ids: this.delCompanyIds }).then((res) => {
          loading.close();
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: "删除成功",
            });
          } else {
            this.$message({
              type: "error",
              message: res.Message,
            });
          }
          this.getData();
        });
      });
    },
    delCompany() {
      this.delCompanyIds = [];
      let params = {
        seachword: "",
        pageIndex: 1,
        pageSize: 999999999,
      };
      GetCompanyList({ params }).then((res) => {
        this.allCompaniesList = res.Data.list;
        this.delCompanyShow = true;
      });
    },
    // 这里获取再此公司参加过的项目
    jopProject(value) {
      let params2 = {
        pid: this.companyID,
        uid: this.id,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        isPM: value == undefined ? "" : value,
      };
      GetProjectList({ params: params2 }).then((res) => {
        //(res, "参加过的项目");
        this.loading = false;
        this.project = res.Data;
        this.projectList = res.Data.list;
        this.total3 = res.Data.total;
      });
    },
    // 邀请人员
    invitaationUser(row) {
      this.userDetail = row;
      this.deptInvation = true;
      this.deptId = "";
      let params = {
        qid: this.pid,
      };
      GetCorporateGovernanceDepartment({ params }).then((res) => {
        this.qyList = res.Data;
      });
    },
    // 邀请人员列表
    invitaation() {
      this.invitaationIsShow = true;
      this.GetUserList();
    },
    userHandleSizeChange(val) {
      this.userPagesize = val;
      this.GetUserList();
    },
    userHandleCurrentChange(val) {
      this.userPagenum = val;
      this.GetUserList();
    },
    GetUserList() {
      let params = {
        seachword: this.userQuery,
        pagenum: this.userPagenum,
        pagesize: this.userPagesize,
      };
      GetUserList({ params }).then((res) => {
        this.userList = res.Data.list;
        this.loading = false;
        this.userTotal = res.Data.total;
      });
    },
    // 邀请
    invation() {
      let invateArr = [];
      invateArr[0] = {
        Account: this.userDetail.Account,
        Phone: this.userDetail.PhoneNumber,
        Email: this.userDetail.Email,
        DeptId: this.deptId,
        CompanyId: this.pid,
      };
      invateArr = JSON.stringify(invateArr);
      InviteCorporateGovernanceUser({ model: invateArr }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            message: "邀请成功",
            type: "success",
          });
          this.deptInvation = false;
        } else {
          this.$message({
            message: "邀请失败",
            type: "warning",
          });
          this.deptInvation = false;
        }
      });
    },
    showAll() {
      let params = {
        seachword: this.query,
        bid: "null",
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        qid: this.comp01,
      };
      // 这里是获得部门下得项目
      GetCompanyProjectList({ params }).then((res) => {
        //(res, "这里是获得部门下得项目");
        this.projectList = res.Data.lsit;
        this.total = res.Data.total;
      });
    },
    modelView(row) {
      let params = `modelId=${row.mode01}^@^type=viewModel`;
      params = Base64.encode(params);
      let url = window.location.origin + `/#/viewModel?Code=${params}`;
      window.open(url);
    },
    modelListInfo(row) {
      this.showModelList = true;
      let params = {
        xid: row.proj01,
        seachword: "",
        pageSize: 10000,
        pageIndex: 1,
      };
      GetProjectModelList({ params }).then((res) => {
        this.ModelList = res.Data.list;
      });
    },
    onAvatarChange(file, fileList) {
      this.imageUrl1 = URL.createObjectURL(file.raw);
    },
    addEnterpriseTrue() {
      this.permissionsList = ["zhmx", "scmx", "tzmk"];
      var d2 = new Date(new Date());
      d2.setFullYear(d2.getFullYear() + 1);
      d2.setDate(d2.getDate() - 1);
      var isTime = [
        new Date()
          .toLocaleString()
          .replace(/\//g, "-")
          .replace(/\上午/g, " ")
          .replace(/\下午/g, " "),
        d2
          .toLocaleString()
          .replace(/\//g, "-")
          .replace(/\上午/g, " ")
          .replace(/\下午/g, " "),
      ];
      this.addqiye.comp14 = isTime;
      this.addqiye.comp09 = 100;
      this.addqiye.comp11 = 1000;
      this.addqiye.comp12 = 10;
      this.imageUrl1 = "";
      this.addEnterprise1 = true;
      setTimeout(() => {
        this.first();
      }, 100);
    },
    first() {
      var that = this;
      // 模拟城市-无联动/无搜索
      var selector1 = $("#city-picker-selector1").cityPicker({
        dataJson: cityData,
        renderMode: true,
        search: true,
        storage: true,
        autoSelected: true,
        shorthand: false,
        code: "cityCode",
        level: 2,
        onChoiceEnd: function () {
          that.addqiye.comp06 = selector1.getCityNameVal();
        },
      });
    },
    first2() {
      var that = this;
      // 模拟城市-无联动/无搜索
      var selector1 = $("#city-picker-selector2").cityPicker({
        dataJson: cityData,
        renderMode: true,
        search: true,
        storage: true,
        autoSelected: true,
        shorthand: false,
        code: "cityCode",
        level: 2,
        onChoiceEnd: function () {
          that.editorForm.comp06 = selector1.getCityNameVal();
        },
      });
      var addr = this.editorForm.comp06.split("/");
      if (addr.length == 2) {
        if (addr[0].trim() != "") {
          selector1.setCityVal(addr[0]);
        }
        this.detialAdree2 = addr[1];
        this.editorForm.comp06 = this.editorForm.comp06.split("/")[0];
      }
    },
    first3() {
      var that = this;
      // 模拟城市-无联动/无搜索
      var selector1 = $("#city-picker-selector3").cityPicker({
        dataJson: cityData,
        renderMode: true,
        search: true,
        storage: true,
        autoSelected: true,
        shorthand: false,
        code: "cityCode",
        level: 2,
        onChoiceEnd: function () {
          that.addForm.user10 = selector1.getCityNameVal();
        },
      });
    },
    // 上传模型
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    editModelHandleChange(file, fileList) {
      this.editModelFileList = fileList.slice(-3);
    },
    beforeUpload(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("addModelList", JSON.stringify(this.addModelList));
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix.toLowerCase();
      const isLt500M = file.size / 1024 / 1024 <= 1024;
      if (this.uploadType.indexOf(extension) == -1) {
        this.$message({
          message: `上传文件只能是${this.uploadType}格式!`,
          type: "warning",
        });
        this.loading2 = false;
      }
      if (!isLt500M) {
        this.$message({
          message: "上传文件大小不能超过500MB!",
          type: "warning",
        });
      }
      return extension || isLt500M;
    },
    editModelBeforeUpload(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("editModel", JSON.stringify(this.editModel));
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix.toLowerCase();
      const isLt500M = file.size / 1024 / 1024 <= 1024;
      if (this.uploadType.indexOf(extension) == -1) {
        this.$message({
          message: `上传文件只能是${this.uploadType}格式!`,
          type: "warning",
        });
        this.loading2 = false;
      }
      if (!isLt500M) {
        this.$message({
          message: "上传文件大小不能超过500MB!",
          type: "warning",
        });
      }
      return extension || isLt500M;
    },
    // 上传成功
    uploadSuccess(code) {
      this.loading2 = false;
      this.updataModel1 = false;
      this.$message({
        type: code.Code > 0 ? "success" : "error",
        message: code.Message,
      });
      this.modelList();
    },
    editModelUploadSuccess(res) {
      this.editModelLoading = false;
      this.editModel1 = false;
      this.$message({
        type: res.Code > 0 ? "success" : "error",
        message: res.Message,
      });
      this.modelList();
    },
    uploadError() {
      this.loading2 = false;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    // 这里上传模型
    updataModel() {
      this.changUploadModel = true;
      // 6/9
    },
    updataModelShow() {
      this.updataModel1 = true;
      this.updataModelTitle = "上传SVFZIP文件";
      this.uploadType = "svfzip";
      this.accept = ".svfzip";
      this.actionUrl = this.$store.state.baseUrl + "/api/UploadModelFile";
    },
    updataModelShowREVIT() {
      this.updataModel1 = true;
      this.updataModelTitle = "上传RVT,NWD文件";
      this.uploadType = this.nvtypes.join(",");
      this.accept = this.nvtypes.join(",");
      this.actionUrl = this.$store.state.baseUrl + "/api/UploadModelRvt";
    },
    updataEditModelShow() {
      this.editModel1 = true;
      this.updataEditModelTitle = "上传SVFZIP文件";
      this.uploadType = "svfzip";
      this.accept = ".svfzip";
      this.editModelActionUrl =
        this.$store.state.baseUrl + "/api/UpdateModelFile";
    },
    updataEditModelShowREVIT() {
      this.editModel1 = true;
      this.updataEditModelTitle = "上传RVT,NWD文件";
      this.uploadType = this.nvtypes.join(",");
      this.accept = this.nvtypes.join(",");
      this.actionUrl = this.$store.state.baseUrl + "/api/UpdateModelRvt";
    },
    // 这里上传模型
    addModel() {
      this.addModelList.mode13 = this.comp01;
      let params = JSON.stringify(this.addModelList);
      if (this.fileList.length > 0) {
        this.$refs.upload.submit();
        this.loading2 = true;
      } else {
        this.$message({
          type: "warning",
          message: "请选择文件后上传",
        });
      }
    },
    editModelList() {
      this.editModel.mode13 = this.comp01;
      let params = JSON.stringify(this.editModel);
      if (this.editModelFileList.length > 0) {
        this.$refs.editModelList.submit();
        this.editModelLoading = true;
      } else {
        let fd = new FormData();
        for (var key in this.editModel) {
          fd.append(key, this.editModel[key]);
        }
        UpdateModelFile(fd).then((res) => {
          this.$message({
            type: res.Code == 1 ? "success" : "warning",
            message: res.Message,
          });
          this.editModel1 = false;
          this.modelList();
        });
      }
    },
    exam01() {
      //(this.addForm.comp14);
    },
    // 这里编辑
    editorDialogFormVisible(row) {
      this.editorEnterprise1 = true;
      this.updataLogo.qid = row.comp01;
      this.pid = row.comp01;
      let params = {
        cid: row.comp01,
      };
      GetCompanyinfo({ params }).then((res) => {
        this.editorForm = res.Data;
        if (this.editorForm.comp13) {
          this.editorForm.comp13 = this.editorForm.comp13.split(",");
          this.permissionsList = this.editorForm.comp13;
        }
        this.editorForm.comp14 = this.editorForm.comp14.split(",");
        //console.log(this.editorForm.comp14);
        this.imageUrl = this.$store.state.baseUrl + this.editorForm.comp10;
        setTimeout(() => {
          this.first2();
        }, 100);
      });
    },
    // 这里确定编辑了昂
    editorEnterprise() {
      this.editorForm.comp13 = this.permissionsList;
      this.editorForm.comp06 = this.editorForm.comp06 + "/" + this.detialAdree2;
      let params = JSON.stringify(this.editorForm);
      EditCompany({ model: params }).then((res) => {
        if (res.Code == 1) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.editorEnterprise1 = false;
          this.getData();
        } else {
          this.$message.error(res.Message);
        }
      });
    },
    // 这里是新增企业
    addEnterprise(form, form1) {
      if (this.imageUrl1 == "") {
        this.$message.error("请选择图片");
        return;
      }
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.$refs[form].validate((valid) => {
            if (valid) {
              this.addqiye.comp06 =
                this.addqiye.comp06 + "/" + this.detialAdree;
              this.addqiye.comp13 = this.permissionsList.join(",");
              this.$refs.upload2.submit();
              this.getData();
              this.addqiye = this.$options.data.call(this).addqiye;
              this.imageUrl1 = this.$options.data.call(this).imageUrl1;
            }
          });
        }
      });
    },
    // 这里是项目
    openproject(row) {
      // //(row)
      this.project1 = true;
      this.comp01 = row.comp01;
      var params = {
        pid: this.comp01,
      };
      GetProjectgroupZTree(params).then((res) => {
        this.dataDept = res.Data;
        this.zNodes = res.Data;
        this.init(res.Data);
        this.loading = false;
        //(res, "企业下的部门");
        this.bid = "";
        this.getprojectlist();
      });
    },
    getprojectlist() {
      let params2 = {
        seachword: this.query2,
        bid: this.ids,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        qid: this.comp01,
      };
      GetCompanyProjectList({ params: params2 }).then((res) => {
        //(res);
        this.projectList = res.Data.lsit;
        this.total4 = res.Data.total;
      });
    },
    init() {
      var _this = this;

      var selectNode;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: true,
        },
        data: {
          key: {
            name: "prgp02",
          },
          simpleData: {
            enable: true,
            idKey: "prgp01",
            pIdKey: "prgp05",
          },
        },
        edit: {
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false,
          drag: {
            isMove: true,
            inner: true,
            prev: false,
            next: false,
          },
        },
        callback: {
          onCheck: onCheck,
          onClick: onclick,
        },
      };
      this.zTeeObj = $.fn.zTree.init($("#deptTree"), setting, this.zNodes);
      this.zTeeObj.checkAllNodes(true);

      var checkedNodes = this.zTeeObj.getCheckedNodes();
      _this.ids = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        _this.ids += _split + element.prgp01;
        _split = ",";
      });
      _this.getprojectlist();
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj.getCheckedNodes();
        _this.ids = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          _this.ids += _split + element.prgp01;
          _split = ",";
        });
        _this.getprojectlist();
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.pageIndex = 1;
        _this.ids = treeNode.prgp01;
        _this.getprojectlist();
      }
    },

    // 菜单激活回调
    handselect(index, indexPath) {
      //(index, indexPath);
      this.bid = index;
      this.bb();
    },
    bb() {
      let params = {
        seachword: this.query2,
        bid: this.ids,
        pageIndex: this.pageIndex3,
        pageSize: this.pageSize3,
        qid: this.comp01,
      };
      // 这里是获得部门下得项目
      GetCompanyProjectList({ params }).then((res) => {
        //(res);
        this.projectList = res.Data.lsit;
        this.total4 = res.Data.total;
      });
    },

    // 查看用户详细信息
    // 这里是查看
    seeDialogFormVisible(row) {
      this.seeDialogFormVisible1 = true;
      let params = { id: row.id };
      this.id = row.id;
      // this.companyID = row.Data[0].comp01;
      GetUserInfo({ params }).then((res) => {
        this.userInfoList = res.Data;
        //(res, "userInfoList");
      });
      GetUserCompanyList({ params }).then((res) => {
        //(res, "所属公司");
        this.companyList = res.Data;
        this.companyID = res.Data[0].comp01;
        this.jopProject();
      });
    },
    // 显示模型管理器页面
    modelList() {
      this.modelList3 = true;
      let params = {
        bid: this.comp01,
        seachword: this.modelQuery,
        pageIndex: this.pageIndex4,
        pageSize: this.pageSize4,
      };
      GetModelList({ params }).then((res) => {
        this.modelList1 = res.Data.list;
        this.total5 = res.Data.total;
      });
    },
    handleOpen(key, keyPath) {
      // //(key);
      this.bid = key;
      let params = {
        seachword: this.query2,
        bid: this.bid,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        qid: this.comp01,
      };
      GetCompanyProjectList({ params }).then((res) => {
        //(res);
        this.projectList = res.Data.lsit;
      });
    },
    handleClose(key, keyPath) {},
    // 查看项目详情
    seeModelList(row) {
      this.projectDetails = true;
      let params = {
        id: row.proj01,
      };
      GetProjectInfo({ params }).then((res) => {
        this.projectInfo = res.Data;
        //(res);
      });
    },
    // 这里是查看模型
    seeModel(row) {
      this.$store.commit("sessionModelUrl2", row.mode09);
      this.flushSession();
      let routeData = this.$router.resolve({
        name: "viewModel",
        path: "/viewModel",
      });
      window.open(routeData.href, "_blank");
    },
    // 这里删除模型
    deleteModel(row) {
      this.$confirm("此操作将永久删除该模型, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: row.mode01,
          };
          DelModelFile(params).then((res) => {
            if (res.Code === 1) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.modelList3 = false;
              this.modelList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 编辑模型
    editModelDetil(row) {
      // this.editModel1 = true;
      this.changEditUploadModel = true;
      this.editModel = JSON.parse(JSON.stringify(row));
    },
    // 设置企管
    setAdmin(row) {
      //(row);
      let params = {
        uid: row.id,
        pid: this.pid,
      };
      SettingCompanyAdmin({ params }).then((res) => {
        if (res.Code == 1) {
          this.$message({
            type: "success",
            message: "设置成功",
          });
        }
        this.aa();
        //(res);
      });
    },
    // 取消企业管理
    outAdmin(row) {
      let params = {
        uid: row.id,
        pid: this.pid,
      };
      CanelCompanyAdmin({ params }).then((res) => {
        if (res.Code == 1) {
          this.$message({
            type: "success",
            message: "取消成功",
          });
        }
        this.aa();
        //(res);
      });
    },
    // 这里是上传图片logo
    handleAvatarSuccess(res, file) {
      if (res.Code == 1) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.$message({
          type: "success",
          message: "添加企业成功",
        });
        this.addEnterprise1 = false;
        this.getData();
      } else {
        this.$message({
          type: "warning",
          message: "添加企业失败",
        });
      }
      this.$refs.upload2.clearFiles();
    },
    // 这里是编辑企业logo
    handleAvatarSuccess2(res, file) {
      if (res.Code == 1) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.$message({
          type: "success",
          message: "修改企业Logo成功",
        });
        this.addEnterprise1 = false;
      } else {
        this.$message({
          type: "warning",
          message: "修改企业Logo失败",
        });
      }
    },
    beforeAvatarUpload(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("model", this.addqiye);
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension =
        suffix === "png" ||
        suffix === "jpg" ||
        suffix === "bmp" ||
        suffix === "tif" ||
        suffix === "webp" ||
        suffix === "jpeg";

      const isLt10M = file.size / 1024 / 1024 < 10;
      //(suffix);
      if (!extension) {
        this.$message({
          message: "上传文件只能是图片类型",
          type: "warning",
        });
        this.loading2 = false;
      }
      if (!isLt10M) {
        this.$message({
          message: "上传文件大小不能超过10MB!",
          type: "warning",
        });
      }
      return extension && isLt10M;
    },
    beforeAvatarUpload2(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("updataLogo", this.updataLogo);
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension =
        suffix === "png" ||
        suffix === "jpg" ||
        suffix === "bmp" ||
        suffix === "tif" ||
        suffix === "webp" ||
        suffix === "jpeg";
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!extension) {
        this.$message({
          message: "上传文件只能是图片类型!",
          type: "warning",
        });
        this.loading2 = false;
      }
      if (!isLt10M) {
        this.$message({
          message: "上传文件大小不能超过10MB!",
          type: "warning",
        });
      }
      return extension && isLt10M;
    },
    // 导出表格所用
    exportExcel() {
      // 设置当前日期
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let name = year + "" + month + "" + day;
      // //(name)
      /* generate workbook object from table */
      //  .table要导出的是哪一个表格
      var wb = XLSX.utils.table_to_book(
        document.querySelector(".enterprise-table")
      );
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        //  name+'.xlsx'表示导出的excel表格名字
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          name + ".xlsx"
        );
      } catch (e) {
        // if (typeof console !== "undefined") //(e, wbout);
      }
      return wbout;
    },
    // 这里是查看用户列表
    userDialogFormVisible(row) {
      this.userDialogFormVisible1 = true;
      this.comp01 = row.comp01;
      this.pid = row.comp01;
      this.uploadData.companyId = row.comp01;
      this.aa();
    },
    // 这里是查看用户列表
    aa() {
      let params = {
        seachword: this.userName,
        pid: this.comp01,
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      GetCompnayUsers({ params }).then((res) => {
        this.userList2 = res.Data.list;
        this.total2 = res.Data.total;
        //(res);
      });
    },
    //职位
    async GetCompanyTitel() {
      let params = {
        cid: this.pid,
      };
      let res = await GetCompanyTitel({ params });
      this.positionList = res.Data;
    },
    //部门--所属组织
    async GetProjectDept() {
      let params = {
        pid: this.pid,
      };
      let res = await GetProjectDept({ params });
      this.removeNullChild(res.Data);
      this.deptIDList = res.Data;
    },
    removeNullChild(data) {
      data.forEach((v) => {
        if (v.children.length == 0) {
          delete v.children;
        } else {
          this.removeNullChild(v.children);
        }
      });
    },
    // 这里是新增员工
    adduser() {
      this.addDialogFormVisible = true;
      this.GetCompanyTitel();
      this.GetProjectDept();
      setTimeout(() => {
        this.first3();
      }, 100);
      this.addForm = {
        user01: 0,
        user02: "",
        user03: "",
        user04: "",
        user05: "",
        user06: "",
        user07: "",
        user08: "",
        user09: "",
        user10: "",
        user11: "",
        user12: "",
        deptIds: "",
        position: "",
      };
    },
    adduser2(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          var address = this.addForm.user10;
          this.addForm.user10 = this.addForm.user10 + "/" + this.detialAdree3;
          this.deptIds = this.addForm.deptIds[this.addForm.deptIds.length - 1];
          let params = {
            pid: this.pid,
            user: JSON.stringify(this.addForm),
            position: this.addForm.position,
            deptId: this.deptIds,
          };
          AddCompanyUser(params).then((res) => {
            if (res.Code === 1) {
              this.$message({
                type: "success",
                message: "添加成功",
              });
              this.addDialogFormVisible = false;
              this.aa();
            } else {
              this.addForm.user10 = address;
              this.$message({
                type: "warning",
                message: res.Message,
              });
            }
          });
        }
      });
    },
    // 这里获取所有数据
    getData() {
      let params = {
        seachword: this.query,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      GetCompanyList({ params }).then((res) => {
        this.companiesList = res.Data.list;

        this.companiesList.forEach((ele) => {
          ele.comp14 =
            ele.comp14.split(",")[0].substring(0, 10) +
            "  " +
            ele.comp14.split(",")[1].substring(0, 10);
        });
        this.total = res.Data.total;
        //(res);
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleSizeChange2(val) {
      this.pagesize = val;
      this.aa();
    },
    handleSizeChange3(val) {
      this.pageSize2 = val;
      this.jopProject();
    },
    handleSizeChange4(val) {
      this.pageSize3 = val;
      this.bb();
    },
    handleSizeChange5(val) {
      this.pageSize4 = val;
      this.modelList();
    },
    handleCurrentChange(val) {
      //   //(`当前页: ${val}`)
      // //("当前页码"+this.pagesize)
      this.pageIndex = val;
      this.getData();
    },
    handleCurrentChange2(val) {
      this.pagenum = val;
      this.aa();
    },
    handleCurrentChange3(val) {
      this.pageIndex2 = val;
      this.jopProject();
    },
    handleCurrentChange4(val) {
      this.pageIndex3 = val;
      this.bb();
    },
    handleCurrentChange5(val) {
      this.pageIndex4 = val;
      this.modelList();
    },
    // 切换部门
    handleNodeClick(data) {
      //(data);
      this.bid = data.ID;
      this.bb();
    },
    // 关闭菜单栏显示
    adminshow() {
      this.$emit("update:showAdmin", true);
    },
  },
};
</script>
<style lang="less" scoped>
#deptTree {
  height: 500px;
}
.zTreeDiv {
  overflow: auto;
}
.ztree li span {
  color: #fff;
  line-height: 21px;
  margin-right: 2px;
}
.user .search-input {
  width: 300px;
}
table.el-table__header {
  line-height: 60px;
}

.el-button {
  margin: 0;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader {
  text-align: center;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.user-loading {
  display: flex;
  margin: 10px 0;

  p {
    margin: 8px 0 0 10px;
    span {
      color: #007acc;
    }
  }
}
.container {
  margin: 0px;
}
.dome-main {
  padding: 0px;
}
.changUpload {
  height: 50vh;
  text-align: center;
  .ZIP {
    width: 35%;
    height: 75%;
    margin-left: 10%;
    float: left;
    border: 2px solid #eee;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
    p {
      font-size: 14px;
      margin-top: 30px;
      height: 50px;
    }
    img {
      width: 100px;
      margin-top: 50px;
    }
  }
  .ZIP:hover {
    background: #eee;
    border-color: skyblue;
  }
  .REVIT:hover {
    background: #eee;
    border-color: skyblue;
  }
  .REVIT {
    width: 35%;
    height: 75%;
    float: left;
    margin-left: 5%;
    border: 2px solid #eee;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
    p {
      font-size: 14px;
      margin-top: 30px;
      height: 50px;
    }
    img {
      width: 100px;
      margin-top: 50px;
    }
  }
}
//新增
.font-sz24 {
  font-size: 24px;
}
.fr-martop-4 {
  float: right;
  margin-top: -4px;
}
.mar-r80 {
  margin-right: 80px;
}
.mar0-4 {
  margin: 0 4px;
}
.wih-het650 {
  width: 100%;
  // height: 650px;
}
.mar-left4 {
  margin: 0 0 0 4px;
}
.mar-top20 {
  margin-top: 20px;
}
.width80 {
  width: 80%;
}
.mar-bot20 {
  margin-bottom: 20px;
}
.width100 {
  width: 100%;
}
.mar-r10 {
  margin-right: 10px;
}
.mar30-40 {
  margin: 30px 0 40px;
}
.mar-left30 {
  margin-left: 30px;
}

.elAside {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  text-align: center;
}
.mar-left10 {
  margin-left: 10px;
}
.mar-top30 {
  margin-top: 30px;
}
.mar-top10 {
  margin-top: 10px;
}
.mar-left5 {
  margin-left: 5px;
}
</style>
